module.exports = __webpack_public_path__ + "img/kyano-logo-light.c583affe.svg";